import $ from 'jquery';
import {trackViewContent} from '../utilities/facebook-pixel';

export default function initializeTrackListingView() {
  const $fbqData = $('#js-fbq-data');

  if ($fbqData.length) {
    const fbqContentId = $fbqData.data('fbq-content-id');
    const fbqProductType = $fbqData.data('fbq-product-type');

    trackViewContent(fbqContentId, fbqProductType);
  }
}
